(function() {

  var alert = $('.c-alert');
  var btnCloseAlert = $('.js-btn-close-alert');

  btnCloseAlert.click(function(){
    $(this).parent(alert).fadeOut(300);
  });

})(jQuery);